import MyInVitiation from './Invitation';

export default MyInVitiation;